import {
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView
} from '../../../../../utils/page';

import {
    onClickActiveAll,
    onClickArchiveAll,
    onClickCreate,
    onClickDeleteAll,
    onClickEdit,
    onClickView
} from '../../../../../utils/form';
import { createLoading } from '../../../../../utils/loading';
import store from '../../../../../store/index';
import lodash from 'lodash';
import { reactive } from 'vue';

import {
    getLabType,
    getLabTypeKeyByRoleMenuAttributes,
    strConvertToUnderScore
} from '../lab-share.logic';
import {
    createColumnBoolean,
    createColumnInput,
    createColumnSelect
} from '../../../../../components/table/c-table.logic';
import i18n from '../../../../../i18n';

export const actionPrefix = 'resource/v1/master/lookup';
export const routerPrefix = 'topic-units';

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const { isLoading, setIsLoading } = createLoading();
export const createColumns = ({ data }) => {
    return [
        createColumnSelect({
            visible: () => data.labAttributes.length > 1,
            title: () => i18n.global.t('model.lookup.modelGroup.LAB_TYPE'),
            customRender: ({ record }) => {
                const labType = data.labTypes.filter((lab) => lab.key == lodash.replace(lodash.camelCase(record.group), 'Unit', ''));
                return <div>{labType[0].value}</div>;
            },
            dataIndex: 'refLabType.id',
            inputProp: ({ field }) => {
                return {
                    list: ({ searchQuery }) => getLabType({ searchQuery }).then(arrays => {
                        return arrays.filter(item => data.labAttributes.includes(item?.key));
                    }),
                    'onUpdate:value': (value) => {
                        field.searchValue = value;
                        data.searchValue = value;
                    },
                    optKey: 'key',
                    optLabel: 'value'
                };
            },
            align: 'center',
            search: {
                visible: () => data.labAttributes.length > 1,
                name: 'group',
                type: 'String',
                operator: '=',
                getValue: ({ value }) => strConvertToUnderScore({
                    input: {
                        data: value.key,
                        transform: { suffix: '_UNIT' }
                    }
                })
            }
        }),
        /*   createColumnInputNumber({
               title: () => i18n.global.t("views.labTopicUnit.seq"),
               dataIndex: "seq",
               comma: false,
               inputProp: () => ({ comma: false })
           }),*/
        createColumnInput({ title: () => i18n.global.t('views.labTopicUnit.key'), dataIndex: 'key', align: 'center' }),
        createColumnInput({ title: () => i18n.global.t('views.labTopicUnit.value'), dataIndex: 'value', align: 'center' }),
        createColumnBoolean({
            title: () => i18n.global.t("views.labTopicUnit.isNW"),
            dataIndex: "attribute.isNW",
            search: { visible: () => false },
            sorter: false,
            width: 40
        }),
        createColumnBoolean({
            title: () => i18n.global.t("views.labTopicUnit.isDW"),
            dataIndex: "attribute.isDW",
            search: { visible: () => false },
            sorter: false,
            width: 40
        }),
        createColumnBoolean({
            title: () => i18n.global.t("views.labTopicUnit.isNV"),
            dataIndex: "attribute.isNV",
            search: { visible: () => false },
            sorter: false,
            width: 40
        }),
        /*    createColumnDate({
                title: () => i18n.global.t("model.createDate"),
                dataIndex: "createDate"
            }),
            createColumnDate({
                title: () => i18n.global.t("model.updateDate"),
                dataIndex: "updateDate"
            })*/
    ];
};

export const initState = ({ props, data }) => {
    const menuContext = props.menuContext;
    data.labAttributes = getLabTypeKeyByRoleMenuAttributes({ props }) || [];
    data.topicUnitGroups = data.labAttributes.map(item => strConvertToUnderScore({
        input: {
            data: item,
            transform: { suffix: '_UNIT' }
        }
    }));
    getLabType({ searchQuery: null }).then(res => {
        data.labTypes = res;
        if (state.columns.length == 0) {
            state.columns = createColumns({ props, data });
        }
        state.manages = [
            createManageSelect({ menuContext }),
            createManageActive({
                menuContext,
                onClick: ({ rowSelection }) => onClickActiveAll({
                    rowSelection,
                    callActiveAll,
                    state,
                    onSearch: (search) => onSearch({ ...search, data }),
                    setIsLoading
                })
            }),
            createManageArchive({
                menuContext,
                onClick: ({ rowSelection }) => onClickArchiveAll({
                    rowSelection,
                    callArchiveAll,
                    state,
                    onSearch: (search) => onSearch({ ...search, data }),
                    setIsLoading
                })
            }),
            createManageDelete({
                menuContext,
                onClick: ({ rowSelection }) => onClickDeleteAll({
                    rowSelection,
                    callDeleteAll,
                    state,
                    onSearch: (search) => onSearch({ ...search, data }),
                    setIsLoading
                })
            }),
            createManageExportCsv({ menuContext })
        ];
        state.manageExtras = [createManageExtraCreate({
            menuContext,
            onClick: () => onClickCreate({ routerPrefix })
        })];
        state.rowActions = [
            createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
            createRowActionEdit({ menuContext, onClick: ({ record }) => onClickEdit({ record, routerPrefix }) })
        ];
    });
};

export const onSearch = ({ page, data }) => {
    setIsLoading(true);
    window.onSearch?.({ page });
    const sort = page.sort || [];
    const where = page.where || [];
    const filterLabTopicUnitGroups = lodash.cloneDeep(data.topicUnitGroups);
    const whereAll = [...where, {
        name: 'group',
        type: 'String',
        operator: 'in',
        value: filterLabTopicUnitGroups
    }];
    const criteria = {
        criteria: {
            ...page,
            data: [],
            where: whereAll,
            sort: [...sort, { name: 'refParent.key', type: 'ASC' }, { name: 'seq', type: 'ASC' }]
        }
    };
    return callSearch(criteria)
        .then(page => state.page = { ...page, where, sort })
        .finally(() => setIsLoading(false));

};

export const state = reactive({
    columns: [],
    page: createPage({
        options: {
            select: []
        }
    }),
    tableOptions: { search: { activeKey: 'Search' } }
});

